export default __webpack_public_path__ + "static/media/CPV.e16fb12b.svg";